import React, { useState } from 'react';
import {
  Pagination as MuiPagination,
  styled,
  PaginationProps as MuiPaginationProps,
  Stack,
} from '@mui/material';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';
import styles from 'new/elements/ReadStats/ReadStats.module.scss';

interface PaginationProps {
  stickyBottom?: boolean;
}

const MuiPaginationStyled = styled(MuiPagination)({
  '.MuiPaginationItem-page': {
    backgroundColor: 'var(--color-outline)',
    fontWeight: 500,

    '&.Mui-selected': {
      backgroundColor: 'var(--color-primary-500)',
    },
  },
});

export const Pagination = (props: PaginationProps & MuiPaginationProps) => {
  const { stickyBottom } = props;
  const [page, setPage] = useState(props.page || 1);

  useDidUpdateEffect(() => {
    setPage(props.page);
  }, [props.page]);

  const onChange = (e, page) => {
    setPage(page);
    e.persist();
    if (typeof props.onChange === 'function') {
      props.onChange(e, page);
    }
  };

  if (stickyBottom) {
    return (
      <Stack className={styles.pagination}>
        <MuiPaginationStyled
          size="small"
          shape="rounded"
          color="primary"
          {...props}
          onChange={onChange}
          page={page}
        />
      </Stack>
    );
  }

  return (
    <MuiPaginationStyled
      size="small"
      shape="rounded"
      color="primary"
      {...props}
      onChange={onChange}
      page={page}
    />
  );
};
